import React from "react";
import FunctionDefinedComponents, {RolledChildType} from "../handler-components/FunctionDefinedComponents";
import {LoginResponse} from "../../rest/jtmc/models/LoginResponse";
import {storageFunctions} from "../../storage";
import {LoginConfirmResponse} from "../../rest/jtmc/models/LoginConfirmResponse";
import {OrderContextValues} from "../../contexts/OrderContext";

interface state {
    code: string
}

interface props {
    orderContext: OrderContextValues,
    children: any
}

export default class DiscountCodeComponents extends FunctionDefinedComponents <props, state> {
    constructor(props: any) {
        super(props);
        this.state = {
            code: "",
        }
    }

    set() {
        this.props.orderContext.setDiscountCode(this.state.code)
    }

    rolledChildren(): RolledChildType {
        return [
            {
                role: "input",
                visible: true,
                props: {
                    value: this.state.code,
                    placeholder: "اگر کد تخفیف دارید اینجا وارد کنید",
                    onChangeText: (t: string) => {
                        this.setState({
                            code: t
                        })
                    }
                },
                children: null,
            },
            {
                role: "button",
                visible: true,
                props: {
                    onPress: () => {
                        this.set()
                    }
                },
                children: "default",
            }
        ];
    }
}